/* eslint-disable camelcase */
import { Click, Page, User } from "@companion-core/shared/app/Interfaces/tracking";
import { useConfigStore } from "@companion-core/shared/app/Store/configStore";
import { getLang } from "./lang";

interface Datalayer extends Page, Click, User {
  event: string;
  piano_id?: number;
  one_trust_data_domain_script?: string;
  digital_control_room_script_url?: string;
}

declare global {
  interface Window {
    dataLayer: Datalayer[];
  }
}

export function sendOneTrustId() {
  const { one_trust_data_domain_script } = useConfigStore.getState().publicConfig?.data;
  window?.dataLayer.push({
    event: "OneTrust Data Domain Script",
    one_trust_data_domain_script,
  });
}

export function sendDigitalControlRoomId() {
  const { digital_control_room } = useConfigStore.getState().publicConfig?.data;
  const language = getLang();
  window?.dataLayer.push({
    event: "Digital Control Room Data Domain Script",
    digital_control_room_script_url: digital_control_room.script_urls[language],
  });
}

export function sendCookieBannerId() {
  const { cookie_banner_type } = useConfigStore.getState().publicConfig?.data;
  if (cookie_banner_type === "one-trust") sendOneTrustId();
  if (cookie_banner_type === "digital-control-room") sendDigitalControlRoomId();
}
